import React from 'react';
import Spiner from '../Components/Admin/Spiner/Spiner';
import { Outlet } from 'react-router-dom';
import Auth from '../Components/Admin/Auth/Auth';
import TitleMeta from '../Components/TitleMeta/TitleMeta';
import { useUser } from '../Components/Admin/UserContext/UserContext'; // Importar el hook del contexto (ajusta la ruta si es necesario)

export default function MainLayout() {
    // Consumir el estado directamente del contexto global
    const { usuario, loading } = useUser();

    return (
        <div>
            <TitleMeta />
            {loading ? (
                <Spiner />
            ) : usuario?.idUsuario ? (
                <Outlet />
            ) : (
                <Auth />
            )}
        </div>
    );
}